import tw, { styled } from 'twin.macro';

export const MatrixRatingWrapper = styled.div`
  ${tw`overflow-x-auto overflow-y-visible w-full`};
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c3c4cd;
  }
`;

export const MatrixRatingTable = styled.table`
  ${tw`border-solid border border-faintgray border-collapse w-full`}
  border-radius: 3px;
  font-size: var(--formFontSize);
  text-transform: var(--formLabelTransform);
  color: var(--formBodyLabelColor, var(--formTextColor));
  font-family: var(--formFontType, 'Circular Std') !important;

  ${({ noBorder }) =>
    noBorder &&
    `
    border: none;
  `}

  ${({ noBorder, isMobileView }) =>
  !noBorder && isMobileView &&
    `
    border: 1px solid rgba(34,36,38,.15);
  `}
`;

export const TableHead = styled.thead`
  ${({ stacked, unstackable, isMobileView }) =>
    ((stacked && !unstackable) || (!unstackable && isMobileView)) &&
    `
    display: none;
  `}
`;

export const TableRow = styled.tr`
  ${tw`border-b border-tableGrey`};
  border-bottom-style: solid;

  ${({ stacked, unstackable }) =>
    stacked && !unstackable &&
    `
    display: block;
  `}

  ${({ noBorder }) =>
    noBorder &&
    `
    border: none;
  `}

  ${({ unstackable, isMobileView }) =>
  !unstackable && isMobileView &&
    `
    display:block;
    padding-top: 1em;
    padding-bottom: 1em;
    border-bottom: 1px solid rgba(0,0,0,.1);
    box-shadow: 0 -1px 0 0 rgba(0,0,0,.1) inset;
  `}

  ${({ noBorder, unstackable, isMobileView }) =>
  noBorder && !unstackable && isMobileView &&
    `
    border: none;
    box-shadow: none;
  `}
`;

export const MatrixHead = styled.th`
  ${tw`border-b border-l border-faintgray p-3 font-normal text-base text-center cursor-auto opacity-70`}
  border-bottom-style: solid;
  font-size: var(--formFontSize);
  border-bottom-color: rgba(34,36,38,.1);
  border-left: 1px solid rgba(34, 36, 38, 0.1);
  color: var(--formBodyLabelColor, var(--formTextColor, #777));

  min-width: ${({ stacked, unstackable, isHead }) => ((!stacked || unstackable) ? (isHead ? '200px' : '100px') : 'auto')};
  max-width: ${({ stacked, unstackable, isHead }) => ((!stacked || unstackable) ? (isHead ? '200px' : '100px') : 'auto')};

  ${({ noBorder }) =>
    noBorder &&
    `
    border: none;
  `}

  &:first-of-type {
    border-left: none;
  }
`;

export const MatrixData = styled.td`
  ${tw`border-l border-t border-faintgray p-3 opacity-70`}
  border-left-style: solid;
  border-left-color: rgba(34,36,38,.15);
  color: var(--formBodyLabelColor, var(--formTextColor, #777));

  min-width: ${({ stacked, unstackable, isQuestion }) => ((!stacked || unstackable) ? (isQuestion ? '200px' : '100px') : 'auto')};
  max-width: ${({ stacked, unstackable, isQuestion }) => ((!stacked || unstackable) ? (isQuestion ? '200px' : '100px') : 'auto')};

  &.rating {
    text-align: center;
  }

  ${({ isQuestion }) => isQuestion && tw`opacity-90`}

  ${({ stacked, unstackable }) =>
    stacked && !unstackable &&
    `
    display: block;
    text-align: left !important;
    border: 1px solid #eee;
  `}

  :not(:first-of-type)::before {
    ${({ stacked, unstackable, isMobileView }) =>
    ((stacked || isMobileView) && !unstackable) &&
    `
      content : attr(data-question);
      width: 50% !important;
      margin-right: 5px;
      display: inline-block;
      font-weight: normal;
    `};
  }

  > i.icon.star.empty:before {
    content: '\\f005';
  }

  > i.icon.empty:before {
    font-size: 14px;
    color: var(--formFieldBorderColor, var(--formTextColor, #d4d4d5));
  }

  ${({ stacked, unstackable, isMobileView }) =>
    isMobileView && (!stacked || unstackable) &&
      `
    min-width: 100%;
    max-width: 100%;
  `}

  ${({ unstackable, isMobileView }) =>
    !unstackable && isMobileView &&
    `
    display: block;
    border: 1px solid #eee;
  `}

  ${({ noBorder, stacked, unstackable, isMobileView }) =>
  (noBorder || (noBorder && stacked && !unstackable) || (noBorder && !unstackable && isMobileView)) &&
    `
    border: none;
  `}

  ${({ isMobileView }) =>
    isMobileView &&
    `
    &.rating {
      text-align: left;
    }
  `}

  ${({ unstackable, isMobileView }) =>
    isMobileView && unstackable &&
      `
    &.rating {
      text-align: center;
    }
  `}
`;

export const InputRadio = styled.input`
  ${tw`cursor-pointer opacity-60 w-4 h-4`};
  accent-color: black;

  &:checked {
    ${tw`opacity-100`};
  }
`;
